import { setLocale } from "react-redux-i18n";
import _ from "lodash";
import { I18n } from "react-redux-i18n";
import Constants from "../../../AppConstants/Constants";
import Utilities from "../../../Helpers/Utilities";
import { toggleBlockingStatus } from "../../Status/Actions";
import { receivedUserInfo, redirectToLoginPage } from "../../Account/Actions";
import {
    getCategories,
    getNewProducts,
    getKits,
    getDevices,
    getPlans,
    getAccessories,
    getPanasonicAccessories,
    getPanasonicT1Accessories,
    getZebraAccessories,
    getZebraTC26Accessories,
    getZebraTC58Accessories,
    getZebraTC78Accessories,
    getSamsungAccessories,
    getUniversalAccessories,
    getVtrackItems,
    getLineHaulItems,
    getServices,
    getRentals
} from "../../Catalog/Actions";
import { getProductDetails } from "../../Product/Actions";
import { getCart, updateTempCart, updateTempCartKitUI, updateTempWirelessPlan } from "../../Cart/Actions";
import { getOrderSummary } from "../../Checkout/Actions";
import { getOrderDetail } from "../../Account/Actions";
import { getTopics, getTopicDetails } from "../../Topics/Actions";
import { getNivoSlider } from "../../Metadata/Actions";
import { receivedServerError } from "../../Error/Actions";
import { LANGUAGES_RECEIVED, LANGUAGE_SET, CURRENCIES_RECEIVED, CURRENCY_SET } from "../Constants";

export function getLanguages(cb) {
    return function(dispatch) {
        dispatch(toggleBlockingStatus(true));

        return fetch(Utilities.buildUrl("/Metadata/Languages"), {
            ...Constants.FETCH_REQUEST_CONFIG,
            method: "GET"
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                } else {
                    return res.json();
                }
            })
            .then(json => {
                dispatch(receivedServerError(false));
                dispatch(receivedLanguages(json.availableLanguages));
                dispatch(toggleBlockingStatus(false));

                if (cb && typeof cb === "function") {
                    cb(json.availableLanguages);
                }
            })
            .catch(error => {
                if (error.status === 401 || error.status === 403) {
                    dispatch(redirectToLoginPage());
                    dispatch(toggleBlockingStatus(false));
                } else {
                    if (error && typeof error.text === "function") {
                        error.text().then(res => {
                            dispatch(receivedServerError(true, res));
                            dispatch(receivedServerError(false));
                            dispatch(toggleBlockingStatus(false));
                        }).catch(e => {
                            dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                            dispatch(receivedServerError(false));
                            dispatch(toggleBlockingStatus(false));
                        });
                    } else {
                        dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                        dispatch(receivedServerError(false));
                        dispatch(toggleBlockingStatus(false));
                    }
                }
            });
    };
}

function receivedLanguages(data) {
    return {
        type: LANGUAGES_RECEIVED,
        payload: data
    };
}

export function setLanguage(data, location = null, config = null, updateDatabase = false) {
    return function(dispatch, getState) {
        dispatch(languageSet(data.language));
        dispatch(setLocale(data.language.languageCulture));

        if (updateDatabase) {
            const formData = Utilities.serializeJson(data);

            return fetch(Utilities.buildUrl("/Account/SetLanguage"), {
                method: "POST",
                cache: "no-cache",
                credentials: "same-origin",
                body: formData
            })
                .then(res => {
                    if (!res.ok) {
                        throw res;
                    }

                    return res.json();
                })
                .then(json => {
                    dispatch(receivedUserInfo(json));

                    if (location && config) {
                        getData(location, config, dispatch, getState);
                    }
                })
                .catch(error => {
                    if (error && typeof error.text === "function") {
                        error.text().then(res => {
                            console.log(res);
                        }).catch(e => {
                            console.log("There was an error getting data. Please contact your administrator for assistance.");
                        });
                    } else {
                        console.log("There was an error getting data. Please contact your administrator for assistance.");
                    }
                });
        }
    };
}

function languageSet(data) {
    return {
        type: LANGUAGE_SET,
        payload: data
    };
}

export function getCurrencies(cb) {
    return function(dispatch) {
        dispatch(toggleBlockingStatus(true));

        return fetch(Utilities.buildUrl("/Metadata/Currencies"), {
            ...Constants.FETCH_REQUEST_CONFIG,
            method: "GET"
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                } else {
                    return res.json();
                }
            })
            .then(json => {
                dispatch(receivedServerError(false));
                dispatch(receivedCurrencies(json.availableCurrencies));
                dispatch(toggleBlockingStatus(false));

                if (cb && typeof cb === "function") {
                    cb(json.availableCurrencies);
                }
            })
            .catch(error => {
                if (error.status === 401 || error.status === 403) {
                    dispatch(redirectToLoginPage());
                    dispatch(toggleBlockingStatus(false));
                } else {
                    if (error && typeof error.text === "function") {
                        error.text().then(res => {
                            dispatch(receivedServerError(true, res));
                            dispatch(receivedServerError(false));
                            dispatch(toggleBlockingStatus(false));
                        }).catch(e => {
                            dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                            dispatch(receivedServerError(false));
                            dispatch(toggleBlockingStatus(false));
                        });
                    } else {
                        dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                        dispatch(receivedServerError(false));
                        dispatch(toggleBlockingStatus(false));
                    }
                }
            });
    };
}

function receivedCurrencies(data) {
    return {
        type: CURRENCIES_RECEIVED,
        payload: data
    };
}

export function setCurrency(data, location = null, config = null, updateDatabase = false) {
    return function(dispatch, getState) {
        dispatch(currencySet(data.currency));

        if (updateDatabase) {
            const formData = Utilities.serializeJson(data);

            return fetch(Utilities.buildUrl("/Account/SetCurrency"), {
                method: "POST",
                cache: "no-cache",
                credentials: "same-origin",
                body: formData
            })
                .then(res => {
                    if (!res.ok) {
                        throw res;
                    }

                    return res.json();
                })
                .then(json => {
                    dispatch(receivedUserInfo(json));

                    if (location && config) {
                        getData(location, config, dispatch, getState);
                    }
                })
                .catch(error => {
                    if (error && typeof error.text === "function") {
                        error.text().then(res => {
                            console.log(res);
                        }).catch(e => {
                            console.log("There was an error getting data. Please contact your administrator for assistance.");
                        });
                    } else {
                        console.log("There was an error getting data. Please contact your administrator for assistance.");
                    }
                });
        }
    };
}

function currencySet(data) {
    return {
        type: CURRENCY_SET,
        payload: data
    };
}

function getData({ pathname, search }, config, dispatch, getState) {
    const localPathName = pathname.toLowerCase();
    const state = getState();

    dispatch(toggleBlockingStatus(true));

    dispatch(getCategories());
    dispatch(getNewProducts(true, true, true));
    dispatch(getTopics());
    dispatch(getNivoSlider());
    dispatch(getCart());
    dispatch(getAccessories(config.ACCESSORIES_CATEGORY_ID, true));
    dispatch(getServices(config.SERVICES_CATEGORY_ID));

    if (localPathName === Constants.ENDPOINTS.KITS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.BUILD_A_KIT.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.DEVICES.toLowerCase()) {
        dispatch(getPlans(config.DATA_PLANS_CATEGORY_ID, false, true));
    }

    if (localPathName === Constants.ENDPOINTS.KITS.toLowerCase()) {
        dispatch(getKits(config.KITS_CATEGORY_ID));

        if (state.selectedKitProductId > 0) {
            const productId = state.selectedKitProductId;
            dispatch(getProductDetails(productId, false, false, true));
        }
    } else if (localPathName === Constants.ENDPOINTS.DEVICES.toLowerCase()) {
        dispatch(getDevices(config.DEVICES_CATEGORY_ID));

        if (state.selectedDeviceProductId > 0) {
            const productId = state.selectedDeviceProductId;
            dispatch(getProductDetails(productId, false, false, true));
        }
    } else if (localPathName === Constants.ENDPOINTS.BUILD_A_KIT.toLowerCase() ||
        // localPathName === Constants.ENDPOINTS.DEVICES.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.DEVICE_COMPARISON.toLowerCase()) {
        dispatch(getDevices(config.DEVICES_CATEGORY_ID, true, true, true, 1, () => {
            if (localPathName === Constants.ENDPOINTS.BUILD_A_KIT.toLowerCase()) {
                updateTempCartData(dispatch, getState);
                updateTempCartUIData(dispatch, getState);
            }
        }));
    } else if (localPathName === Constants.ENDPOINTS.PANASONIC_ACCESSORIES.toLowerCase()) {
        dispatch(getPanasonicAccessories(config.PANASONIC_ACCESSORIES_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.PANASONIC_T1_ACCESSORIES.toLowerCase()) {
        dispatch(getPanasonicT1Accessories(config.PANASONIC_T1_ACCESSORIES_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.ZEBRA_ACCESSORIES.toLowerCase()) {
        dispatch(getZebraAccessories(config.ZEBRA_ACCESSORIES_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.ZEBRA_TC26_ACCESSORIES.toLowerCase()) {
        dispatch(getZebraTC26Accessories(config.ZEBRA_TC26_ACCESSORIES_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.ZEBRA_TC58_ACCESSORIES.toLowerCase()) {
        dispatch(getZebraTC26Accessories(config.ZEBRA_TC58_ACCESSORIES_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.ZEBRA_TC78_ACCESSORIES.toLowerCase()) {
        dispatch(getZebraTC26Accessories(config.ZEBRA_TC78_ACCESSORIES_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.SAMSUNG_ACCESSORIES.toLowerCase()) {
        dispatch(getSamsungAccessories(config.SAMSUNG_ACCESSORIES_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.UNIVERSAL_ACCESSORIES.toLowerCase()) {
        dispatch(getUniversalAccessories(config.UNIVERSAL_ACCESSORIES_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.VTRACK.toLowerCase()) {
        dispatch(getVtrackItems(config.VTRACK_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.LINEHAUL.toLowerCase()) {
        dispatch(getLineHaulItems(config.LINEHAUL_CATEGORY_ID, true));
    } else if (localPathName === Constants.ENDPOINTS.PRIVACY_POLICY.toLowerCase()) {
        dispatch(getTopicDetails(config.TOPICS.PRIVACY_POLICY_TOPIC_ID));
    } else if (localPathName === Constants.ENDPOINTS.RETURN_REFUND_POLICY.toLowerCase()) {
        dispatch(getTopicDetails(config.TOPICS.RETURN_REFUND_POLICY_TOPIC_ID));
    } else if (localPathName === Constants.ENDPOINTS.ADVANCED_EXCHANGE.toLowerCase()) {
        dispatch(getTopicDetails(config.TOPICS.ADVANCED_EXCHANGE_TOPIC_ID));
    }else if (localPathName === Constants.ENDPOINTS.SERVICES.toLowerCase()) {
        dispatch(getTopicDetails(config.TOPICS.OUR_SERVICES_TOPIC_ID));
    } else if (localPathName === Constants.ENDPOINTS.COMPANY.toLowerCase()) {
        dispatch(getTopicDetails(config.TOPICS.OUR_COMPANY_POLICY_TOPIC_ID));
    } else if (localPathName === Constants.ENDPOINTS.BUYING_GUIDE.toLowerCase()) {
        dispatch(getTopicDetails(config.TOPICS.BUYING_GUIDE_TOPIC_ID));
    } else if (localPathName === Constants.ENDPOINTS.PAYMENT_OPTIONS.toLowerCase()) {
        dispatch(getTopicDetails(config.TOPICS.PAYMENT_OPTIONS_TOPIC_ID));
    } else if (localPathName === Constants.ENDPOINTS.KITS_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.DEVICES_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.ZEBRA_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.ZEBRA_TC26_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.ZEBRA_TC58_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.ZEBRA_TC78_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.PANASONIC_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.PANASONIC_T1_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.SAMSUNG_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.UNIVERSAL_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.RENTALS_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.VTRACK_DETAILS.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.LINEHAUL_DETAILS.toLowerCase()){
        const queryStringParameters = Utilities.getQueryStringParameters(search);
        dispatch(getProductDetails(queryStringParameters.product, false, false, true, Utilities.scrollToTop));
    } else if (localPathName === Constants.ENDPOINTS.PAY_IN_FULL_CHECKOUT.toLowerCase() ||
        localPathName === Constants.ENDPOINTS.LEASE_CHECKOUT.toLowerCase()) {
        dispatch(getOrderSummary());
    } else if (localPathName === Constants.ENDPOINTS.ORDER_CONFIRMATION.toLowerCase()) {
        const orderId = state.orderDetail.orderDetail.id;
        dispatch(getOrderDetail(orderId));
    } else if (localPathName === Constants.ENDPOINTS.RENTALS.toLowerCase()) {
        dispatch(getRentals(config.RENTALS_CATEGORY_ID, true));
    }
}

function updateTempCartData(dispatch, getState) {
    const state = getState();
    const { tempCart, devices, plans } = state;

    if (tempCart.Kit) {
        const selectedKitId = Object.keys(tempCart.Kit)[0];
        const selectedKit = _.find(devices, d => d.id == selectedKitId);
        const selectedKitAttribute = _.find(selectedKit.productAttributes, a => a.productAttributeId === tempCart.Kit[selectedKitId].productAttributeId);
        const selectedKitAttributeValue = !selectedKitAttribute ? null : _.find(selectedKitAttribute.values, v => v.id === tempCart.Kit[selectedKitId].attributeValueId);
        const accessoriesTempCart = _.cloneDeep(tempCart);
        delete accessoriesTempCart.Kit;
        delete accessoriesTempCart.Plan;

        const newTempCart = {};

        newTempCart.Kit = {};

        newTempCart.Kit[selectedKit.id] = {
            ...selectedKit,
            quantity: tempCart.Kit[selectedKitId].quantity,
            attributeValueId: !selectedKitAttributeValue ? null : selectedKitAttributeValue.id,
            productAttributeId: !selectedKitAttribute ? null : selectedKitAttribute.id,
            productAttributeMapId: !selectedKitAttributeValue ? null : selectedKitAttributeValue.productAttributeMappingId,
            productAttributePrice: !selectedKitAttributeValue ? null : selectedKitAttributeValue.priceAdjustmentValue
        };

        if (tempCart.Plan) {
            const selectedPlanId = Object.keys(tempCart.Plan)[0];
            const selectedPlan = _.find(plans, d => d.id == selectedPlanId);
            const selectedPlanAttribute = _.find(selectedPlan.productAttributes, a => a.productAttributeId === tempCart.Plan[selectedPlanId].productAttributeId);
            const selectedPlanAttributeValue = _.find(selectedPlanAttribute.values, v => v.id === tempCart.Plan[selectedPlanId].attributeValueId);

            newTempCart.Plan = {};

            newTempCart.Plan[selectedPlan.id] = {
                ...selectedPlan,
                quantity: tempCart.Plan[selectedPlanId].quantity,
                attributeValueId: !selectedPlanAttributeValue ? null : selectedPlanAttributeValue.id,
                productAttributeId: !selectedPlanAttribute ? null : selectedPlanAttribute.id,
                productAttributeMapId: !selectedPlanAttributeValue ? null : selectedPlanAttributeValue.productAttributeMappingId,
                productAttributePrice: !selectedPlanAttributeValue ? null : selectedPlanAttributeValue.priceAdjustmentValue
            };
        }

        _.each(accessoriesTempCart, (value, key) => {
            _.each(value, (product, productId) => {
                let item = null;

                _.each(selectedKit.productAttributes, a => {
                    const attributeValue = _.find(a.values, v => v.associatedProductId == productId);

                    if (attributeValue) {
                        item = attributeValue.product;
                    }
                });

                if (item) {
                    const itemAttribute = _.find(item.productAttributes, a => a.productAttributeId === tempCart[key][productId].productAttributeId);
                    let itemAttributes = {};

                    if (itemAttribute) {
                        const itemAttributeValue = _.find(itemAttribute.values, v => v.id === tempCart[key][productId].attributeValueId);
                        itemAttributes = {
                            attributeValueId: !itemAttributeValue ? null : itemAttributeValue.id,
                            productAttributeId: !itemAttribute ? null : itemAttribute.id,
                            productAttributeMapId: !itemAttributeValue ? null : itemAttributeValue.productAttributeMappingId,
                            productAttributePrice: !itemAttributeValue ? null : itemAttributeValue.priceAdjustmentValue
                        };
                    }

                    newTempCart[key] = {};

                    newTempCart[key][productId] = {
                        ...item,
                        ...itemAttributes,
                        quantity: tempCart[key][productId].quantity
                    };
                }
            });
        });

        dispatch(updateTempCart());

        _.each(newTempCart, (cartItem, category) => {
            const obj = {};
            obj[category] = cartItem;

            dispatch(updateTempCart(obj));
        });
    }
}

function updateTempCartUIData(dispatch, getState) {
    const state = getState();
    const { tempCartKitUI, devices, plans } = state;
    let selectedKit;

    if (tempCartKitUI.Kit) {
        const selectedKitId = Object.keys(tempCartKitUI.Kit)[0];
        selectedKit = _.find(devices, d => d.id == selectedKitId);
        const selectedKitAttribute = _.find(selectedKit.productAttributes, a => a.productAttributeId === tempCartKitUI.Kit[selectedKitId].productAttributeId);
        const selectedKitAttributeValue = !selectedKitAttribute ? null : _.find(selectedKitAttribute.values, v => v.id === tempCartKitUI.Kit[selectedKitId].attributeValueId);
        const accessoriesTempCart = _.cloneDeep(tempCartKitUI);
        delete accessoriesTempCart.Kit;
        delete accessoriesTempCart.Plan;

        const newTempCart = {};

        newTempCart.Kit = {};

        newTempCart.Kit[selectedKit.id] = {
            ...selectedKit,
            quantity: tempCartKitUI.Kit[selectedKitId].quantity,
            attributeValueId: !selectedKitAttributeValue ? null : selectedKitAttributeValue.id,
            productAttributeId: !selectedKitAttribute ? null : selectedKitAttribute.id,
            productAttributeMapId: !selectedKitAttributeValue ? null : selectedKitAttributeValue.productAttributeMappingId,
            productAttributePrice: !selectedKitAttributeValue ? null : selectedKitAttributeValue.priceAdjustmentValue
        };

        if (tempCartKitUI.Plan) {
            const selectedPlanId = Object.keys(tempCartKitUI.Plan)[0];
            const selectedPlan = _.find(plans, d => d.id == selectedPlanId);
            const selectedPlanAttribute = _.find(selectedPlan.productAttributes, a => a.productAttributeId === tempCartKitUI.Plan[selectedPlanId].productAttributeId);
            const selectedPlanAttributeValue = _.find(selectedPlanAttribute.values, v => v.id === tempCartKitUI.Plan[selectedPlanId].attributeValueId);
            const planAttributes = {
                attributeValueId: !selectedPlanAttributeValue ? null : selectedPlanAttributeValue.id,
                productAttributeId: !selectedPlanAttribute ? null : selectedPlanAttribute.id,
                productAttributeMapId: !selectedPlanAttributeValue ? null : selectedPlanAttributeValue.productAttributeMappingId,
                productAttributePrice: !selectedPlanAttributeValue ? null : selectedPlanAttributeValue.priceAdjustmentValue
            };

            newTempCart.Plan = {};

            newTempCart.Plan[selectedPlan.id] = {
                ...selectedPlan,
                ...planAttributes,
                quantity: tempCartKitUI.Plan[selectedPlanId].quantity
            };

            dispatch(updateTempWirelessPlan(planAttributes));
        }

        _.each(accessoriesTempCart, (value, key) => {
            _.each(value, (product, productId) => {
                let item = null;

                _.each(selectedKit.productAttributes, a => {
                    const attributeValue = _.find(a.values, v => v.associatedProductId == productId);

                    if (attributeValue) {
                        item = attributeValue.product;
                    }
                });

                if (item) {
                    const itemAttribute = _.find(item.productAttributes, a => a.productAttributeId === tempCartKitUI[key][productId].productAttributeId);
                    let itemAttributes = {};

                    if (itemAttribute) {
                        const itemAttributeValue = _.find(itemAttribute.values, v => v.id === tempCartKitUI[key][productId].attributeValueId);
                        itemAttributes = {
                            attributeValueId: !itemAttributeValue ? null : itemAttributeValue.id,
                            productAttributeId: !itemAttribute ? null : itemAttribute.id,
                            productAttributeMapId: !itemAttributeValue ? null : itemAttributeValue.productAttributeMappingId,
                            productAttributePrice: !itemAttributeValue ? null : itemAttributeValue.priceAdjustmentValue
                        };
                    }

                    newTempCart[key] = {};

                    newTempCart[key][productId] = {
                        ...item,
                        ...itemAttributes,
                        quantity: tempCartKitUI[key][productId].quantity,
                        dummyQuantity: tempCartKitUI[key][productId].dummyQuantity,
                        parentCategory: tempCartKitUI[key][productId].parentCategory,
                        parentProductIds: tempCartKitUI[key][productId].parentProductIds
                    };
                }
            });
        });

        dispatch(updateTempCartKitUI());

        _.each(newTempCart, (cartItem, category) => {
            const obj = {};
            obj[category] = cartItem;

            dispatch(updateTempCartKitUI(obj));
        });
    }
}